import server_paginated_table_component from "@/components/probaworkflows_base_components/ServerPaginatedTable/ServerPaginatedTable.vue";
import pdf_report_signature_modal_component from "@/components/probaworkflows_base_components/PDFReportSignatureModal/PDFReportSignatureModal.vue";
import { get_headers, get_project_id } from "@/utils/constants/constants";
import alert_mixin from "@/utils/mixins/alert_mixin";
import report_template_library_computed from "./report_template_library_computed";
import report_template_library_methods from "./report_template_library_methods";

export default {
  name: "ReportTemplateLibrary",
  components: {
    ServerPaginatedTable: server_paginated_table_component,
    PDFReportSignatureModal: pdf_report_signature_modal_component,
  },
  mixins: [alert_mixin],
  props: {
    title: {
      type: String,
      default: "Saved report templates",
    },
    subtitle: {
      type: String,
      default: "Reuse saved templates and generate a report immediately.",
    },
    initial_target_entity_profile_id: {
      type: [Number, String],
      default: null,
    },
    initial_entity_type_id: {
      type: [Number, String],
      default: null,
    },
    initial_application_id: {
      type: [Number, String],
      default: null,
    },
    include_pdf_templates: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    headers: get_headers(),
    project_id: get_project_id(),
    loading_templates: false,
    searching_templates: false,
    generating_template_id: null,
    standard_templates: [],
    pdf_templates: [],
    search_query: "",
    search_timer: null,
    last_applied_search: "",
    last_generated_report: null,
    page_number: 1,
    page_size: 10,
    selected_template: null,
    signature_modal_visible: false,
    pending_pdf_template_record: null,
  }),
  computed: {
    ...report_template_library_computed,
    initial_entity_type_id_value() {
      const parsed = Number(this.initial_entity_type_id || 0);
      return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
    },
  },
  mounted() {
    this.load_templates();
  },
  beforeDestroy() {
    clearTimeout(this.search_timer);
  },
  methods: report_template_library_methods,
};
